import { render, staticRenderFns } from "./RecargoShow.vue?vue&type=template&id=19643fd6&"
import script from "./RecargoShow.vue?vue&type=script&lang=js&"
export * from "./RecargoShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports